import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Alert } from '@bibliocommons/deprecated-base-alerts';

import Checkbox from 'app/components/deprecated/shared/Checkbox';

import './ShelfPrivacyAlert.scss';

export default function ShelfPrivacyAlert({ setToPublic, handleChange }) {
  return (
    <div className="cp-ugc-shelf-privacy-alert">
      <Alert>
        <strong>
          <FormattedMessage id="ugc_item_is_private" />
        </strong>
        &nbsp;
        <FormattedMessage id="ugc_private_item_info" />
      </Alert>
      <Checkbox
        id="ugc-shelf-privacy-checkbox"
        checked={setToPublic}
        handleChange={handleChange}
        label={<FormattedMessage id="ugc_shelf_privacy_toggle" />}
      />
    </div>
  );
}

ShelfPrivacyAlert.propTypes = {
  handleChange: PropTypes.func.isRequired,
  setToPublic: PropTypes.bool.isRequired
};
